import { Outlet } from 'react-router-dom';

export default function AuthLayout() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-bg-primary">
      <div className="w-full max-w-md p-6">
        {/* Logo */}
        <div className="mb-8 text-center">
          <h1 className="text-3xl font-bold text-primary-500">MotoWalla</h1>
          <p className="mt-2 text-text-secondary">Your Automotive Homepage</p>
        </div>

        <Outlet />
      </div>
    </div>
  );
}
